module.exports = __webpack_public_path__ + "static/media/botton-sm-prev.ffc43723.svg";